import { css } from "@stubhub/broadway-foundation/css";

export const timeChipUnselectedClasses = {
  label: css({ color: "text.subtle" }),
  icon: css({ color: "text.subtle" }),
};

export const squareChipRootClass = css({
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  height: "[36px]",
});

export const filterBarStyle = css({
  display: "flex",
  flexDirection: "row",
  columnGap: "primitives.150",
  rowGap: "primitives.150",
  alignItems: "center",
  paddingBlock: "primitives.150",
  flexWrap: "wrap",
});
